import React, { useContext, useState } from "react";
import './ProductDisplay.css';
import star_icon from '../Assets/star_icon.png';
import star_dull_icon from '../Assets/star_dull_icon.png';
import { ShopContext } from "../../Context/ShopContext";

const ProductDisplay = (props) => {
    const { product } = props;
    const { addToCart } = useContext(ShopContext);
    const [selectedSize, setSelectedSize] = useState(null);

    if (!product || !product.sizes) {
        // Render a loading state or null if product data is not yet available
        return <div className="product-display container"><p>Loading product...</p></div>;
    }

    const handleSizeClick = (size) => {
        setSelectedSize(size);
    };

    const renderSizes = () => {
        let sizes = [];
        // A cleaner way to get the sizes based on type
        sizes = product.sizes[product.type] || [];
        
        return sizes.map(size => (
            <button 
                key={size} 
                className={`size-selector__option ${selectedSize === size ? "selected" : ""}`} 
                onClick={() => handleSizeClick(size)}
            >
                {size}
            </button>
        ));
    };

    const handleAddToCart = () => {
        if (!selectedSize) {
            alert('Please select a size before adding to cart');
            return;
        }
        addToCart(product.id, selectedSize);
        alert('Item added to cart'); // We can upgrade this to a toast notification later
    };

    return (
        <div className="product-display container">
            {/* Left Column: Image */}
            <div className="product-display__image-wrapper">
                <img className="product-display__main-img" src={product.image} alt={product.name} />
            </div>

            {/* Right Column: Info & Actions */}
            <div className="product-display__info-wrapper">
                <h1>{product.name}</h1>

                {/* We'll keep the star rating simple for now */}
                <div className="product-display__reviews">
                    <img src={star_icon} alt="" />
                    <img src={star_icon} alt="" />
                    <img src={star_icon} alt="" />
                    <img src={star_icon} alt="" />
                    <img src={star_dull_icon} alt="" />
                    <p>(122 Reviews)</p>
                </div>

                <div className="product-display__prices">
                    <div className="price--new">R{product.new_price}</div>
                    <div className="price--old">R{product.old_price}</div>
                </div>

                <p className="product-display__description">
                    {product.description}
                </p>

                <div className="product-display__size-selector">
                    <h2 className="size-selector__title">Select Size</h2>
                    <div className="size-selector__options">
                        {renderSizes()}
                    </div>
                </div>

                <button onClick={handleAddToCart} className="product-display__cta-button">
                    Add to Cart
                </button>

                <div className="product-display__meta">
                    <p className="meta__item"><span>Category :</span> {product.category}</p>
                    <p className="meta__item"><span>Tags :</span> Modern, Latest</p>
                </div>
            </div>
        </div>
    );
};

export default ProductDisplay;